<!-- 项目文件 -->
<template>
    <div class="w100p bgf9">
        <Header></Header>
        <Titleimg :img="bgImg"></Titleimg>
        <div class="pt25 pl16 pr16 pb25 ">
            <p class="fs16 c333 disinblock posre textc w100p flexc">
                <span class="border-bottom1">
                    合作方式
                </span>
            </p>
            <div class="pt25 bradius2 ">
                <P class="bg1f8 textc pt10 pb10 alit flexc">
                    <img class="w18 h18" src="../../../public/img/img96.png" alt="">
                    <span class=" cfff fs14 pl8">加盟代理</span>
                </P>
                <van-row class="bgfff">
                    <van-col span="12">
                        <div class="textc pt16 pb16 brdashed">
                            <img class="w50 h56" src="../../../public/img/img82.png" alt="">
                            <P class="pt4 pb4 c333 fs14">驾培管理系统</P>
                            <div class="lh18">
                                <P class='fs12 c999'>区域合作伙伴</P>
                                <p class='fs12 c999'>拓展合作驾校</p>
                            </div>
                        </div>
                    </van-col>
                    <van-col span="12">
                        <div class="textc pt16 pb16">
                            <img class="w50 h56" src="../../../public/img/img83.png" alt="">
                            <P class="pt4 pb4 c333 fs14">驾校招生小程序</P>
                            <div class="lh18"> 
                                <P class='fs12 c999'>招募区域合</P>
                                <p class='fs12 c999'>自媒体渠道合作伙伴</p>
                            </div>
                        </div>
                    </van-col>
                    <van-col span="12">
                        <div class="textc pt16 pb16 brdashed btdashed">
                            <img class="w50 h56" src="../../../public/img/img84.png" alt="">
                            <P class="pt4 pb4 c333 fs14">精品模拟题</P>
                            <div class="lh18">
                                <P class='fs12 c999'>招募区域驾校</P>
                                <p class='fs12 c999'>自媒体渠道合作伙伴</p>
                            </div>
                        </div>
                    </van-col>
                    <van-col span="12">
                        <div class="textc pt16 pb16 btdashed">
                            <img class="w50 h56" src="../../../public/img/img85.png" alt="">
                            <P class="pt4 pb4 c333 fs14">驾考无忧</P>
                            <div class="lh18"> 
                                <P class='fs12 c999'>招募区域</P>
                                <p class='fs12 c999'>自媒体渠道合作伙伴</p>
                            </div>
                        </div>
                    </van-col>
                </van-row>
            </div>
        </div>

        <div class="mt16 pl16 pr16 pb25 ">
            <div class="bgfff bradius2">
                <P class="bg1f8 textc pt10 pb10 alit flexc">
                    <img class="w18 h18" src="../../../public/img/img96.png" alt="">
                    <span class=" cfff fs14 pl8">渠道合作</span>
                </P>
                <van-row>
                    <van-col span="12">
                        <div class="textc pt16 pb16 brdashed">
                            <img class="w50 h56" src="../../../public/img/img86.png" alt="">
                            <P class="pt4 pb4 c333 fs14">渠道广告曝光合作</P>
                            <div class="lh18"> 
                                <P class='fs12 c999'>CPM/CPT</P>
                                <p class='fs12 c999'>合作模式</p>
                            </div>
                        </div>
                    </van-col>
                    <van-col span="12">
                        <div class="textc pt16 pb16">
                            <img class="w50 h56" src="../../../public/img/img87.png" alt="">
                            <P class="pt4 pb4 c333 fs14">产品分销</P>
                            <div class="lh18">
                                <P class='fs12 c999'>CPM/CPT</P>
                                <p class='fs12 c999'>合作模式</p>
                            </div>
                        </div>
                    </van-col>
                    <van-col span="12">
                        <div class="textc pt16 pb16 brdashed btdashed">
                            <img class="w50 h56" src="../../../public/img/img88.png" alt="">
                            <P class="pt4 pb4 c333 fs14">平台招生</P>
                            <div class="lh18"> 
                                <P class='fs12 c999'>CPA</P>
                                <p class='fs12 c999'>合作模式</p>
                            </div>
                        </div>
                    </van-col>
                    <van-col span="12">
                        <div class="textc pt16 pb16 btdashed">
                            <img class="w50 h56" src="../../../public/img/img89.png" alt="">
                            <P class="pt4 pb4 c333 fs14">平台换量</P>
                            <div class="lh18"> 
                                <P class='fs12 c999'>内容推广</P>
                                <p class='fs12 c999'>相互引流</p>
                            </div>
                        </div>
                    </van-col>
                </van-row>
            </div>
        </div>
        
        <div class=" pl16 pr16 pb90 ">
            <p class="fs16 c333 disinblock posre textc w100p flexc">
                <span class="border-bottom1">
                    合作商家
                </span>
            </p>
            <div class="pt10 bradius2 ">
                <van-row class="" gutter="20">
                    <van-col span="12" class="mt15" >
                        <div class="box-shadow22 textc pt16 pb16 bgfff">
                            <P class="posre">
                                <span class="border-bottom1">
                                    <img class="w90 h100" src="../../../public/img/img90.png" alt="">
                                </span>
                            </P>
                            <div class="lh18 pt20">
                                <P class='fs12 c999'>小程序为商家</P>
                                <p class='fs12 c999'>打造数字化经营阵地</p>
                            </div>
                        </div>
                    </van-col>
                    <van-col span="12" class="mt15">
                        <div class="box-shadow22 textc pt16 pb16 bgfff">
                            <P class="posre">
                                <span class="border-bottom1">
                                    <img class="w120 h100" src="../../../public/img/img91.png" alt="">
                                </span>
                            </P>
                            <div class="lh18 pt20">
                                <P class='fs12 c999'>小程序为商家</P>
                                <p class='fs12 c999'>打造数字化经营阵地</p>
                            </div>
                        </div>
                    </van-col>
                    <van-col span="12" class="mt15">
                        <div class="box-shadow22 textc pt16 pb16 bgfff">
                            <P class="posre">
                                <span class="border-bottom1">
                                    <img class="w105 h90" src="../../../public/img/img92.png" alt="">
                                </span>
                            </P>
                            <div class="lh18 pt20">
                                <P class='fs12 c999'>小程序为商家</P>
                                <p class='fs12 c999'>打造数字化经营阵地</p>
                            </div>
                        </div>
                    </van-col>
                    <van-col span="12" class="mt15">
                        <div class="box-shadow22 textc pt16 pb16 bgfff">
                            <P class="posre">
                                <span class="border-bottom1">
                                    <img class="w130 h90" src="../../../public/img/img93.png" alt="">
                                </span>
                            </P>
                            <div class="lh18 pt20">
                                <P class='fs12 c999'>小程序为商家</P>
                                <p class='fs12 c999'>打造数字化经营阵地</p>
                            </div>
                        </div>
                    </van-col>

                    <van-col span="12" class="mt15">
                        <div class="box-shadow22 textc pt16 pb16 bgfff">
                            <P class="posre">
                                <span class="border-bottom1">
                                    <img class="w130 h90" src="../../../public/img/img94.png" alt="">
                                </span>
                            </P>
                            <div class="lh18 pt20">
                                <P class='fs12 c999'>小程序为商家</P>
                                <p class='fs12 c999'>打造数字化经营阵地</p>
                            </div>
                        </div>
                    </van-col>

                    <van-col  span="12" class="mt15">
                       
                    </van-col>
                </van-row>
            </div>
        </div>
        <ApplyCoope></ApplyCoope>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import Titleimg from '@/components/Titleimg';
    import ApplyCoope from '@/components/ApplyCoope';

    import $ from "jquery";
    export default {
        data() {
            return {
                bgImg: require('../../../public/img/img81.png'),
            };
        },
        components: {
            Header,
            Titleimg,
            Footer,
            ApplyCoope
        },
        methods: {

        },
        created() {

        },
        mounted() {

        },
    }
</script>
<style scoped>
    .brdashed {
        border-right: 1px dashed #e0e0e0;
    }
    
    .btdashed {
        border-top: 1px dashed #e0e0e0;
    }
</style>